module.exports = __webpack_public_path__ + "static/logo-kimia-farma-be88ed4b8ee927f3aa78915ca53bf2e7.png";